import { render, staticRenderFns } from "./MyBorrowRequests.vue?vue&type=template&id=d60fe288&"
import script from "./MyBorrowRequests.vue?vue&type=script&lang=js&"
export * from "./MyBorrowRequests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports